import { Button, Col, ConfigProvider, Form, notification, Row } from "antd";
import es from "antd/lib/locale/es_ES";
import { Banner3 } from "assets/banner3";
import { Banner3Mobile } from "assets/banner3_mobile";
import DOMPurify from "dompurify";
import moment from "moment";
import "moment/locale/es";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import banner1 from "../../assets/BANNER1.jpg";
import banner1mobile from "../../assets/BANNER1_mobile.jpg";
import banner2 from "../../assets/BANNER2.jpg";
import banner2mobile from "../../assets/BANNER2_mobile.jpg";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import {
  CLASSES_ACTIVITY_TYPE,
  getSearcherRouteByType,
} from "../../shared/activityCatalog";
import Sidebar from "../../components/Layout/Sidebar";
import { useMediaQuery } from "../../shared/utils";
import {
  getActivityCatalog,
  getCities,
  getCountries,
  getGeolocationViaIP,
  getClassesByDateRange,
} from "./../../services/http";
import { Calendar, CourtForm, Slider } from "./components";
import { Video } from "./components/video";
import { colors, Content, Layout } from "./Home.styles";

moment.locale("es");
const dateFormat = "DD MMM YYYY";

const Home = () => {
  const today = moment().format("DD MMM YYYY");

  const isDesktop = useMediaQuery("(min-width: 770px)");
  const [selectedDate, setselectedDate] = useState(today);
  const [location, setLocation] = useState({});
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const [setting, setSetting] = useState({});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  const [selectedCityId, setSelectedCityId] = useState(undefined);

  // ESTADO PARA PUNTOS DE RESERVA EN EL CALENDARIO (VISTA DE CLASES)
  const [calendarReservations, setCalendarReservations] = useState(new Set());
  const [, setFetchingCalendarReservations] = useState(false);
  const lastFetchedMonth = useRef("");

  const loadCalendarReservations = useCallback(async (date) => {
    const isClasses = form.getFieldValue("activityType") === CLASSES_ACTIVITY_TYPE;
    if (!isClasses) {
      return;
    }
    
    try {
      const parsedSelectedDate = moment(selectedDate, "DD MMM YYYY");
      const targetDate = date || parsedSelectedDate || moment();
      const monthStr = targetDate.format("YYYY-MM");
      
      const selectedCity = cities.find((city) => city.idciudad === selectedCityId);
      const latitude = selectedCity?.latitud;
      const longitude = selectedCity?.longitud;
      
      const cacheKey = `${monthStr}_${latitude || ""}_${longitude || ""}`;
      if (lastFetchedMonth.current === cacheKey) {
        return;
      }
      lastFetchedMonth.current = cacheKey;

      setFetchingCalendarReservations(true);
      
      const start = targetDate.clone().startOf('month');
      const end = targetDate.clone().endOf('month');
      
      const timeParam = start.unix();
      const endtimeParam = end.unix();

      const response = await getClassesByDateRange({
        time: timeParam,
        endtime: endtimeParam,
        latitude,
        longitude,
        page: '0',
        size: '1000'
      });

      if (response && response.cod === 1000) {
        const dates = new Set();
        (response.data || []).forEach((item) => {
          const dateStr = item.fecha ? item.fecha.substring(0, 10) : "";
          if (dateStr) {
            dates.add(dateStr);
          }
        });
        setCalendarReservations(dates);
      } else {
        setCalendarReservations(new Set());
      }
    } catch (error) {
      console.error("Error loading calendar reservations:", error);
      setCalendarReservations(new Set());
    } finally {
      setFetchingCalendarReservations(false);
    }
  }, [selectedDate, form, selectedCityId, cities]);

  useEffect(() => {
    const isClasses = form.getFieldValue("activityType") === CLASSES_ACTIVITY_TYPE;
    if (isClasses) {
      loadCalendarReservations();
    }
  }, [selectedDate, form, loadCalendarReservations]);

  const updateSelectedDate = (selected) => {
    const formattedDate = selected.format("DD MMM YYYY");
    setselectedDate(formattedDate);
  };

  const disabledDate = (current) => {
    // Deshabilitar los días pasados al actual
    return current && moment().hours() === 23 && moment().minutes() >= 30
      ? current < moment()
      : current < moment(today, "DD MMM YYYY");
  };

  const initialDateTime = {
    date:
      moment().hours() === 23 && moment().minutes() >= 30
        ? moment(selectedDate, dateFormat).add(1, "day")
        : moment(selectedDate, dateFormat),
  };
  const checkGeolocPermissions = async () => {
    try {
      const request = await getGeolocationViaIP();
      if (request.result) {
        const { geodata } = request;
        //console.log({ geodata });
        setLocation((prev) => ({
          latitude: geodata.latitude,
          longitude: geodata.longitude,
          country: geodata.country,
          city: geodata.city,
          code: geodata.countryCode,
        }));
        notification.success({
          message: "Estamos utilizando tu ubicación aproximada",
          description:
            "Utilizamos tu ubicación aproximada para poder brindarte mejores resultados de búsqueda",
          duration: 3,
        });
      }
    } catch (error) {
      notification.warning({
        message: "No podemos acceder a tu ubicación",
        description:
          "Ocurrió un error intentando ubicar tu ubicación de forma aproximada, si el problema persiste por favor contacta a soporte en info@icancha.com",
        duration: 3,
      });
    }
  };

  const requestCountries = async () => {
    try {
      const response = await getCountries();
      ////console.log({ response });
      const { cod, data } = response;
      if (cod === 1000) {
        setCountries(data);
        if (location.country) {
          // console.log({ location });
          const geoCountry = location.country.toLowerCase();
          const isCountryCovered = data.filter((country) =>
            country.nombre.toLowerCase().includes(geoCountry)
          );
          if (isCountryCovered.length >= 1) {
            form.setFieldsValue({ country: isCountryCovered[0].idpais });
            requestCities(isCountryCovered[0].idpais, true);
          }
        }
      } else {
        throw new Error(`${cod}`);
      }
    } catch (error) {
      //console.log('error getCountries: ', error);
      notification.warning({
        message: "No podemos hacer contacto con el servidor iCancha",
        description:
          "Ocurrió un error intentando obtener el listado de paises del servidor, si el problema persiste por favor contacta a soporte en info@icancha.com",
        duration: 3,
      });
    }
  };

  const requestCities = async (idPais, isInitial = false) => {
    try {
      const response = await getCities(idPais);
      ////console.log({ response });
      const { cod, data } = response;
      if (cod === 1000) {
        const geoCity = isInitial ? location?.city?.toLowerCase() : null;
        const sortData = data.sort((a, b) => {
          if (geoCity && a.nombre.toLowerCase() === geoCity) return -1;
          if (geoCity && b.nombre.toLowerCase() === geoCity) return 1;
          return a.nombre.localeCompare(b.nombre);
        });
        setCities(sortData);
        if (isInitial && geoCity) {
          const isCityCovered = data.filter((city) =>
            city.nombre.toLowerCase().includes(geoCity)
          );
          if (isCityCovered.length >= 1) {
            form.setFieldsValue({ city: isCityCovered[0].idciudad });
            setSelectedCityId(isCityCovered[0].idciudad);
          } else {
            form.setFieldsValue({ city: data[0].idciudad });
            setSelectedCityId(data[0].idciudad);
          }
        } else if (isInitial) {
          form.setFieldsValue({ city: data[0].idciudad });
          setSelectedCityId(data[0].idciudad);
        }
      } else {
        throw new Error(`${cod}`);
      }
    } catch (error) {
      //console.log('error requestCities: ', error);
      notification.warning({
        message: "No podemos hacer contacto con el servidor iCancha",
        description:
          "Ocurrió un error intentando obtener el listado de ciudades del servidor, si el problema persiste por favor contacta a soporte en info@icancha.com",
        duration: 3,
      });
    }
  };

  const handleCountryChange = async (idPais) => {
    form.setFieldsValue({ city: undefined });
    setSelectedCityId(undefined);
    setCities([]);
    await requestCities(idPais, false);
  };

  const clearActivityFields = () => {
    form.setFieldsValue({
      activityType: undefined,
    });
  };

  const handleActivityTypeChange = async (activityTypeId) => {
    form.setFieldsValue({
      activityType: activityTypeId,
    });

    if (String(activityTypeId) === CLASSES_ACTIVITY_TYPE) {
      lastFetchedMonth.current = "";
      loadCalendarReservations();
    } else {
      setCalendarReservations(new Set());
    }
  };

  const requestActivityCatalog = async () => {
    try {
      const response = await getActivityCatalog();
      const { cod, data } = response;
      if (cod === 1000) {
        setActivityTypes(data);
        clearActivityFields();
      } else {
        throw new Error(`${cod}`);
      }
    } catch (error) {
      //console.log('error requestSports: ', error);
      notification.warning({
        message: "No podemos hacer contacto con el servidor iCancha",
        description:
          "Ocurrió un error intentando obtener el listado de actividades del servidor, si el problema persiste por favor contacta a soporte en info@icancha.com",
        duration: 3,
      });
    }
  };

  useEffect(() => {
    checkGeolocPermissions();
  }, []);

  useEffect(() => {
    requestCountries();
    requestActivityCatalog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    const setting = async () => {
      try {
        const resp = await fetch("./setting.json");
        const data = await resp.json();
        setSetting(data);
      } catch (e) {
        console.log(e);
      }
    };
    const config = async () => {
      try {
        setLoading(true);
        const resp = await fetch(
          process.env.REACT_APP_SETTING
        );
        const data = await resp.json();
        setSetting(data);
      } catch (e) {
        setting();
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    config();
  }, []);
  const onFinish = (values) => {
    ////console.log({ values });
    const selectedCity = cities.find((city) => city.idciudad === values.city);
    const selectedCountry = countries.find(
      (country) => country.idpais === values.country
    );
    const preparedTime = values.date
      .clone()
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
    const searchParams = {
      date: values.date.format("YYYY-MM-DD"),
      time: preparedTime.unix(),
      activityType: values.activityType,
      activity: undefined,
      sport: undefined,
      latitude: selectedCity?.latitud,
      longitude: selectedCity?.longitud,
      country: selectedCountry?.iso,
    };
    history.push(getSearcherRouteByType(values.activityType), {
      searchParams,
      activityTypes,
    });
  };

  const onFinishFailed = (errorInfo) => {
    //console.log('Failed:', errorInfo);
  };

  return (
    <ConfigProvider locale={es}>
      <Layout>
        {!isDesktop && (
          <>
            <Sidebar pageWrapId={"page-wrap"} right />
          </>
        )}
        <Header
          background={colors.background}
          color={colors.white}
          icon
          home="white"
        />
        <Content >
          <div style={{ maxWidth: "1440px", margin: "auto" }}>
            <div id="Home" />
            <Row className="Row-Contentbg">
              <Col className="Col-contentImg" span={24}>
                <Slider loading={loading} list={setting?.slider?.list ?? []} />

                <Col
                  className="Col-Select--Title"
                  style={{ whiteSpace: "pre-line" }}
                >
                  <div>
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          setting?.slider?.title ?? ""
                        ),
                      }}
                    />
                    <p
                      className="text-big"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          setting?.slider?.description ?? ""
                        ),
                      }}
                    />
                  </div>
                </Col>
              </Col>

              <Col className="Col-menu--content">
                {/* menu landding */}
                <CourtForm
                  activityTypes={activityTypes}
                  cities={cities}
                  countries={countries}
                  disabledDate={disabledDate}
                  form={form}
                  initialDateTime={initialDateTime}
                  onActivityTypeChange={handleActivityTypeChange}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  requestCities={handleCountryChange}
                  updateSelectedDate={updateSelectedDate}
                  calendarReservations={calendarReservations}
                  loadCalendarReservations={loadCalendarReservations}
                  onCityChange={setSelectedCityId}
                />
              </Col>
            </Row>
            <Row
              className="Row-banner1"
              style={{
                maxWidth: "1440px",
              }}
            >
              <Col span={24}>
                <img
                  src={isDesktop ? banner1 : banner1mobile}
                  alt="icon date"
                  style={{ width: "100%", objectFit: "contain" }}
                />
              </Col>
            </Row>

            <Video
              description={setting?.video?.description}
              title={setting?.video?.title}
              url={setting?.video?.url}
              loading={loading}
            />
            <Row
              style={{
                maxWidth: "1440px",
                position: "relative",
              }}
            >
              <Col span={24}>
                <img
                  src={isDesktop ? banner2 : banner2mobile}
                  alt="icon date"
                  style={{ width: "100%", objectFit: "contain" }}
                />
              </Col>
              <div id="Centro-Deportivo" />
              <Col
                className="wpp"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                <Button
                  type="primary"
                  className="buttonws"
                  target="_blank"
                  href={
                    location.countryCode === "EC"
                      ? `https://wa.me/593997220556?text=Hola Equipo iCancha!`
                      : `https://wa.me/573157708440?text=Hola Equipo iCancha!`
                  }
                >
                  WhatsApp
                </Button>
              </Col>
            </Row>
            <Calendar />
            <Row
              style={{
                maxWidth: "1440px",
                position: "relative",
              }}
            >
              <Col span={24}>
                {/* <img
                  src={isDesktop ? banner3 : banner3mobile}
                  alt="icon date"
                  style={{ width: "100%", objectFit: "contain" }}
                /> */}
                {isDesktop ? (
                  <Banner3 title={setting.banner?.["3"]?.title ?? ""} />
                ) : (
                  <Banner3Mobile title={setting.banner?.["3"]?.title ?? ""}/>
                )}

                <Button
                  type="primary"
                  className="buttonws contact"
                  onClick={() => {
                    window.location.href = "#contact";
                  }}
                >
                  Contáctanos
                </Button>
              </Col>
            </Row>
          </div>
        </Content>
        <Footer countries={location.countryCode} />
      </Layout>
    </ConfigProvider>
  );
};

export default Home;
